export default __webpack_public_path__ + "static/media/l2c-logo-vector.fbae82d1.svg";